import { useCallback } from "react";
import * as Actions from "../actions";
import { useDomainUseCase } from "./useDomainUseCase";

export const useLiveChannelActions = () => {
  const { execute } = useDomainUseCase();

  const getLiveChannel = useCallback((liveChannelId) => {
    execute({
      useCase: "GetLiveChannelUseCase",
      params: { id: liveChannelId },
      getLoadingAction: Actions.getLiveChannel,
      getErrorAction: Actions.getLiveChannelError,
      getSuccessAction: Actions.getLiveChannelSuccess,
    });
  }, []);

  return {
    getLiveChannel,
  };
};
